import { inject, Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';

import { JobActivityActions } from './job-activity.actions';

@Injectable({
  providedIn: 'root'
})
export class JobCommentArtifactHandlerService {

  private heldFiles = new Map<string, File>();
  private actions$ = inject(Actions);

  constructor() {
    this.actions$.pipe(
      ofType(JobActivityActions.addCommentFileRemoved, JobActivityActions.replyFileRemoved),
    ).subscribe(({ fileId }) => {
      this.heldFiles.delete(fileId);
    });

    this.actions$.pipe(
      ofType(JobActivityActions.addCommentFilesDiscarded, JobActivityActions.replyFilesDiscarded),
    ).subscribe(({ files }) => {
      for (const { fileId } of files) {
        this.heldFiles.delete(fileId);
      }
    });

    this.actions$.pipe(
      ofType(JobActivityActions.addCommentAttachmentsUploaded, JobActivityActions.replyAttachmentsUploaded),
    ).subscribe(({ fileIds }) => {
      for (const fileId of fileIds) {
        this.heldFiles.delete(fileId);
      }
    });
  }

  holdFile(id: string, file: File): void {
    this.heldFiles.set(id, file);
  }

  getFile(id: string): File | undefined {
    return this.heldFiles.get(id);
  }

}
